module.exports = __webpack_public_path__ + "img/logo_woocommerce.1b74cf1a.svg";